import QuillEventBus, { QuillEvents } from '@/components/texteditor/event-bus';

export default function () {
  QuillEventBus.$emit(QuillEvents.SEARCH_REPLACE, { uuid: this.quill.uuid });
}
